
const Data = {
    setData: async function (key, data) {
        try {
            await localStorage.setItem(key, data);
        } catch (e) {
            console.error(e);
        }
    },

    getData: async function (key) {
        try {
            const value = await localStorage.getItem(key)
            if (value !== null) {
                return value;
            }
            return null;
        } catch (e) {
            console.error(e);
        }
    },

    removeValue: async function (key) {
        try {
            await localStorage.removeItem(key);
        } catch (e) {
            console.error(e);
        }

        console.log('Done.');
    },
};

export default Data;